export * from './browser.storage';
export * from './memory.storage';